import { TYPES } from "./task_count.type";

const initState = {
  totalTask: null,
  unfinishedTaskCount: 0,
};
const taskCountReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_TOTAL_TASK:
      return {
        ...state,
        totalTask: payload,
      };
    case TYPES.SET_UNFINISHED_TASK_COUNT:
      return {
        ...state,
        unfinishedTaskCount: payload,
      };
    default:
      return state;
  }
};

export default taskCountReducer;
